import PropType from 'prop-types';

const FeedbackLink = ({ className, dataElevioId, children }) => {
    const onClick = (e) => {
        e.preventDefault();
        if (dataElevioId && window._elev) {
            window._elev.openModule(dataElevioId);
        }
    };
    return (
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        <a
            href="#!"
            onClick={onClick}
            rel="noreferrer noopener"
            aria-haspopup="true"
            className={className}
            data-zendesk="feedback-link"
        >
            {children}
        </a>
    );
};

FeedbackLink.propTypes = {
    className: PropType.string,
    dataElevioId: PropType.oneOfType([PropType.string, PropType.number]),
};

FeedbackLink.defaultProps = {
    className: 'feedback-button',
};

export default FeedbackLink;
